import {   

    REQUEST_INVOICE_SAVE,
    RECEIVE_INVOICE_SAVE_SUCCESS, RECEIVE_INVOICE_SAVE_ERROR, REQUEST_INVOICE_CREATE,
     RECEIVE_INVOICE_CREATE_SUCCESS, RECEIVE_INVOICE_CREATE_ERROR,
     REQUEST_INVOICE, RECEIVE_INVOICE_SUCCESS

        }  from '../actions/invoice'
        

const DEFAULT_CURRENTINVOICE =   {
                isFetching: false,
                isSaving: false,
                };


export function currentInvoice(state = DEFAULT_CURRENTINVOICE, action) {
    
    switch (action.type) {
        
         case REQUEST_INVOICE_SAVE: {
            var newstate = {
                ...state, 
                isSaving: true
            };
            return newstate;
         }

        case RECEIVE_INVOICE_SAVE_SUCCESS: {                        
            var newstate = {
                ...state,
                ...action.item, 
                isSaving: false
            }                 
            return newstate;            
        }              


        case REQUEST_INVOICE: {                        
            var newstate = {
                ...state,
                isFetching: true
            }                 
            return newstate;            
        }              

        case RECEIVE_INVOICE_SUCCESS: {                        
            var newstate = {
                ...state,
                ...action.item, 
                isFetching: false
            }                 
            return newstate;            
        }              

        
        case REQUEST_INVOICE_CREATE: {
            var newstate = {
                ...state, 
                isSaving: true
            };
            return newstate;
         }

        case RECEIVE_INVOICE_CREATE_SUCCESS: {                        
            var newstate = {
                ...state,
                ...action.item, 
                isSaving: false
            }                 
            return newstate;            
        }              
 

        default: {
            return state;
        }
    }
}
